/*
  * Copyright Mission 42 Ventures, Inc. All rights reserved.
  * Unauthorized copying, distribution, or use is prohibited.
  */

import React from 'react';
import { createPlugin } from '@backstage/core-plugin-api';
import { createCardExtension } from '@backstage/plugin-home';
import { ServiceHealthCardBody } from './ServiceHealthCard';
import { ScopedPullRequestsCardBody } from './ScopedPullRequestsCard';
import { ServicesCardBody } from './ServicesCard';
import { PendingWorkCardBody } from './PendingWorkCard';

// Local plugin hosting the Home cards as plugin-home card extensions so they can
// be placed in CustomHomepageGrid (PLAT-384). The extension supplies the card
// frame + title, so each Content is the card BODY only (no InfoCard) to avoid a
// nested/double card. The plugin-home built-ins (Starred, Recently visited,
// Toolkit) are already card extensions and are used directly in the grid.
const homeCardsPlugin = createPlugin({ id: 'home-cards' });

export const ServiceHealthHomeCard = homeCardsPlugin.provide(
  createCardExtension({
    name: 'ServiceHealth',
    title: 'Service health',
    components: async () => ({ Content: () => <ServiceHealthCardBody /> }),
  }),
);

export const OpenPullRequestsHomeCard = homeCardsPlugin.provide(
  createCardExtension({
    name: 'OpenPullRequests',
    title: 'Open pull requests',
    components: async () => ({ Content: () => <ScopedPullRequestsCardBody /> }),
  }),
);

// Static "Services" frame title; scope context lives in the ScopeRow above the
// grid, so the body renders no heading of its own (avoids a stacked title).
export const ServicesHomeCard = homeCardsPlugin.provide(
  createCardExtension({
    name: 'Services',
    title: 'Services',
    components: async () => ({ Content: () => <ServicesCardBody /> }),
  }),
);

export const PendingWorkHomeCard = homeCardsPlugin.provide(
  createCardExtension({
    name: 'PendingWork',
    title: 'Pending work',
    components: async () => ({ Content: () => <PendingWorkCardBody /> }),
  }),
);

// Announcements is NOT wrapped here: @backstage-community/plugin-announcements'
// AnnouncementsCard renders its own card frame, so wrapping it in a card
// extension would nest two cards. It's placed in the grid as a raw element
// (its own card is the chrome).
